/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Sub_Overview_Contract_SeatsInputs */



/**
* | output |
* | --- |
* | "{seats} seats in your contract" |
*
* @param {Sub_Overview_Contract_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_contract_seats = /** @type {((inputs: Sub_Overview_Contract_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Contract_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} Plätze laut Vertrag`)
	return /** @type {LocalizedString} */ (`${i?.seats} seats in your contract`)
});